// jQueryEasing
jQuery.easing.jswing=jQuery.easing.easeOutExpo,jQuery.extend(jQuery.easing,{easeOutExpo:function(e,n,u,a,r){return n==r?u+a:a*(-Math.pow(2,-10*n/r)+1)+u}});